"use client";

import { useEffect, useRef, type ReactNode } from "react";

const FITS = "data-re-footer-fits";

/** Marks `element` while it fits the view, measured again whenever either changes size; returns the cleanup. */
export function watchFooterHeight(
  element: HTMLElement,
  win: Window & typeof globalThis,
): () => void {
  const measure = () =>
    element.toggleAttribute(FITS, element.offsetHeight <= win.innerHeight);
  measure();
  const resized = new win.ResizeObserver(measure);
  resized.observe(element);
  win.addEventListener("resize", measure);
  return () => {
    resized.disconnect();
    win.removeEventListener("resize", measure);
  };
}

/** Afsløres under siden: the footer under the page, as src/styles/look-page.css lays it out. */
export default function FooterReveal({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(
    () => (ref.current ? watchFooterHeight(ref.current, window) : undefined),
    [],
  );
  return (
    <div ref={ref} data-re-footer-under="">
      {children}
    </div>
  );
}
